import { handleResponse } from 'helper/handleResponse';
import { authHeader } from 'helper/authHeader';
import { baseUrl } from 'helper/ApiCall';
import axios from 'axios';

export const festivalService = {
    getFestivalsPagination,
    getFestival,
    storeFestival,
    updateComment,
    updateCommentData,
    editFestival,
    getFestivalComments,
    getMusicDirectorsForFestival,
    getFestivalMusicDirectors,
    getFestivalAdjudicators,
    storeFestivalMusicDirector,
    storeFestivalAdjudicator,
    getFestivalMusicDirector,
    getFestivalAdjudicator,
    deleteFestival,
    deleteFestivalMusicDirector,
    deleteFestivalAdjudicator,
    editFestivalMusicDirector,
    editFestivalAdjudicator,
    createSheetForFestival,
    getFestivalsAllMusicDirectorsPagination,
    getFestivalsAllAdjudicatorsPagination,
    getPricePerAdjudicationValue,
    storeMDMedia,
    getMDMedia,
    deleteMDMedia
}


function getFestivalsPagination(page, filter, sort, companyId, pageSize){
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };
    if (companyId == null)
        return fetch(baseUrl+'festivalsPagination?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
    else
        return fetch(baseUrl+'festivalsPagination/'+companyId+'?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
}


function getFestival(id){

	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };



    return fetch(baseUrl+'festivals/'+id, requestOptions).then(handleResponse);
}

function getFestivalComments(id, page){
	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(baseUrl+'festival/'+id+'/getCommentsForFestival?page='+page, requestOptions).then(handleResponse);
}

function getMusicDirectorsForFestival(id){
	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(baseUrl+'festival/'+id+'/getMusicDirectorsForFestival', requestOptions).then(handleResponse);
}


function storeFestival(festivalData, companyId){

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(festivalData)
    };

    return fetch(baseUrl+'festival/'+companyId+'/store', requestOptions)
        .then(handleResponse)
        .then(festival => {
            return festival;
        });
}


function updateComment(info, id){
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify({'music_director_id': info.id, 'id':id})
    };

    return fetch(baseUrl+'festival/'+id+'/updateCommentMusicDirector', requestOptions)
            .then(handleResponse)
            .then(festival => {
                return festival;
            })
}

function updateCommentData(info, id){
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(info)
    };

    return fetch(baseUrl+'updateCommentData/'+id, requestOptions)
            .then(handleResponse)
            .then(festival => {
                return festival;
            })
}
function editFestival(id, festivalData){
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(festivalData)
    };

    return fetch(baseUrl+'festival/'+id+'/update', requestOptions)
            .then(handleResponse)
            .then(festival => {
                return festival;
            })
}


function getFestivalMusicDirectors(userId){

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };



    return fetch(baseUrl+'festival/'+userId+'/musicDirectors', requestOptions).then(handleResponse);
}


function getFestivalAdjudicators(userId){

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };



    return fetch(baseUrl+'festival/'+userId+'/adjudicators', requestOptions).then(handleResponse);
}


function storeFestivalMusicDirector(festivalMusicDirectorData, festivalId){
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(festivalMusicDirectorData)
    };

    return fetch(baseUrl+'festival/'+festivalId+'/musicDirector/store', requestOptions)
            .then(handleResponse)
            .then(festival => {
                return festival;
            })
}

function storeFestivalAdjudicator(festivalAdjudicatorData, festivalId){
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(festivalAdjudicatorData)
    };

    return fetch(baseUrl+'festival/'+festivalId+'/adjudicator/store', requestOptions)
            .then(handleResponse)
            .then(festival => {
                return festival;
            })
}
function getFestivalMusicDirector(id){

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };



    return fetch(baseUrl+'musicDirector/'+id, requestOptions).then(handleResponse);
}


function getFestivalAdjudicator(id){

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };



    return fetch(baseUrl+'adjudicator/'+id, requestOptions).then(handleResponse);
}

function deleteFestival(id){
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };


    return fetch(baseUrl+'festival/'+id, requestOptions).then(handleResponse);
}


function deleteFestivalMusicDirector(festivalId, id){
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()

    };


    return fetch(baseUrl+'festival/'+festivalId+'/musicDirector/'+id, requestOptions).then(handleResponse);
}


function deleteFestivalAdjudicator(festivalId, id){
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()

    };


    return fetch(baseUrl+'festival/'+festivalId+'/adjudicator/'+id, requestOptions).then(handleResponse);
}


function editFestivalMusicDirector(festivalUserData, festivalId, id){
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(festivalUserData)
    };

    return fetch(baseUrl+'festival/'+festivalId+'/musicDirector/'+id, requestOptions)
            .then(handleResponse)
            .then(company => {
                return company;
            })
}

function editFestivalAdjudicator(festivalAdjudicatorData, festivalId, id){
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(festivalAdjudicatorData)
    };

    return fetch(baseUrl+'festival/'+festivalId+'/adjudicator/'+id, requestOptions)
            .then(handleResponse)
            .then(company => {
                return company;
            })
}

function createSheetForFestival(festivalId, type, actionType, templateData, updateAndSend) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(templateData)

    };
    return fetch(baseUrl+'generate/'+festivalId+'/'+type+'/'+actionType+'/infoSheets/'+updateAndSend, requestOptions).then(handleResponse).then(response=>{
        return response;
    });
}

function getFestivalsAllMusicDirectorsPagination(page, filter, sort, companyId, pageSize){
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };

    if (companyId == null)
        return fetch(baseUrl+'getAllMusicDirectors?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
    else
        return fetch(baseUrl+'getAllMusicDirectors/'+companyId+'?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
}


function getFestivalsAllAdjudicatorsPagination(page, filter, sort, companyId, pageSize){
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };

    if (companyId == null)
        return fetch(baseUrl+'getAllAdjudicators?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
    else
        return fetch(baseUrl+'getAllAdjudicators/'+companyId+'?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
}


function getPricePerAdjudicationValue(companyId) {
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };
    return fetch(baseUrl+'getPricePerAdjudication/'+companyId, requestOptions).then(handleResponse);
}

function storeMDMedia(MDId, mediaData, callbackProgressUpload = null){
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(mediaData),
        onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if (callbackProgressUpload)
                callbackProgressUpload(percentCompleted);
        }
    };
    return axios.post(baseUrl + 'MDMedia/'+MDId, mediaData, requestOptions).then(
        response => {
            return response.data;
        }
    ).catch(function (error) {
        return Promise.reject(error);
    });
}

function getMDMedia(MDId) {
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };
    return fetch(baseUrl+'MDMedia/'+MDId, requestOptions).then(handleResponse);
}


function deleteMDMedia(MediaId) {
    const requestOptions = {
        method  : 'DELETE',
        headers : authHeader()
    };
    return fetch(baseUrl+'MDMedia/'+MediaId, requestOptions).then(handleResponse);
}



// WEBPACK FOOTER //
// ./src/services/festival.js